import HttpService from "./http.service";

class ContentService extends HttpService {

  list = (params) => this.get("content/list", params);

  create = (params) => this.post("content/store", params);

  createContentsList = (data) => this.post(`common/upload-content`, data);

  update = (id, params) => this.patch(`content/${id}`, params);

  createParentLabel = (data) => this.post(`parent_label/store`, data);
}

export default new ContentService();
